import {HttpClient} from "@angular/common/http";
import { Injectable } from '@angular/core';
import {firstValueFrom} from "rxjs";
import {environment} from "../../../environments/environment";
import {SystemLanguageDto} from "../../dtos/local/SystemLanguage.dto";

@Injectable({
  providedIn: 'root'
})
export class LanguageService {


  private readonly baseUrl = `${environment.api.host}/language/getalllanguages`;

  constructor(
    private http: HttpClient
  ) { }

  async getLanguages() {
    return firstValueFrom(
      this.http.get<SystemLanguageDto[]>(
        this.baseUrl
      )
    );
  }

}
